import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Icon } from "@/components/icons";

export default function ServiceCard({ service }) {
  return (
    <Link
      to={service.to}
      data-testid={`service-card-${service.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
      className="group bg-cream border border-charcoal/20 shadow-md hover:shadow-lg hover:-translate-y-1 transition-all duration-200 p-6 flex flex-col"
    >
      <span className="flex items-center justify-center w-12 h-12 bg-cream-200 text-rust mb-4 group-hover:bg-rust group-hover:text-cream transition-colors">
        <Icon name={service.icon} className="w-6 h-6" />
      </span>
      <h3 className="font-heading text-2xl uppercase text-charcoal leading-none">
        {service.title}
      </h3>
      <p className="text-sm text-charcoal/70 mt-2 leading-relaxed flex-1">{service.desc}</p>
      <span className="mt-4 inline-flex items-center gap-1.5 font-accent uppercase text-xs tracking-widest text-rust">
        Learn more
        <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
      </span>
    </Link>
  );
}
